/* eslint-disable react-hooks/exhaustive-deps */
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import React, { useEffect } from "react";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import { GripVerticalIcon, RefreshCcwIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GenericType } from "@/types";
import { cn } from "@/lib/utils";

export const TableColumnsHandle = ({
  tableKeys,
  tableColumn,
  setTableColumn,
  children,
  onSorting,
  labels,
  formPopupOpen,
  tableKey,
  avoid_list,
}: GenericType) => {
  const [itemList, setItemList] = React.useState<GenericType>([]);

  useEffect(() => {
    if (JSON.stringify(tableKeys) !== JSON.stringify(tableColumn)) {
      setTableColumn(tableKeys);
      setItemList(tableKeys);
    }
  }, [tableKeys, setTableColumn, formPopupOpen]);
  useEffect(() => {
    setTableColumn(tableKeys);
    setItemList(tableKeys);
  }, [formPopupOpen]);

  const onSortEnd = (oldIndex: number, newIndex: number) => {
    const newArray = arrayMoveImmutable(itemList, oldIndex, newIndex);
    setItemList(newArray);
    onSorting(newArray);
  };

  const resetColumnSetting = () => {
    localStorage.removeItem(tableKey);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant={"action"}>{children}</Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        {tableKey ? (
          <Button
            onClick={() => {
              resetColumnSetting();
            }}
            variant={"ghost"}
            className="border-b w-full rounded-none justify-start px-3 py-2 text-sm flex items-center gap-2"
          >
            <RefreshCcwIcon size={14} /> Reset
          </Button>
        ) : null}

        <SortableList
          onSortEnd={onSortEnd}
          draggedItemClassName="dragged"
          className="text-sm space-y-3  px-3 py-2 max-h-[400px] overflow-y-auto"
        >
          {itemList.map((item: string, index: number) => {
            return (
              <SortableItem key={index}>
                <div
                  className={cn(
                    " items-center gap-3 justify-between select-none",
                    avoid_list?.includes(item) ? "hidden" : "flex"
                  )}
                >
                  <div className="flex items-center gap-3">
                    {labels?.[item] || item}
                  </div>
                  <SortableKnob>
                    <GripVerticalIcon size={15} />
                  </SortableKnob>
                </div>
              </SortableItem>
            );
          })}
        </SortableList>
      </PopoverContent>
    </Popover>
  );
};
